import { getData, postData, patchData, putData } from "../apiClient";

const ItemName = "Salary Generate";
const API_URL = "salary-generate";

// get all with pagination
export const GetAll = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

// get item data with id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create item (Bulk Generate Salary)
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      `Create ${ItemName} API error:`,
      error.status === 400 ? error.error || error.data?.message : error.message,
    );
    return {
      data: {
        success: false,
        error:
          error.status === 400
            ? error.data?.message || "Generation Failed"
            : error.message,
        status: error.status,
      },
    };
  }
};

// update status
export const UpdateStatus = async ({ id, status }) => {
  try {
    const result = await patchData(`/${API_URL}/status/${id}`, { status });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} Status API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// Update status (batch)
export const UpdateBatchStatus = async ({ data }) => {
  try {
    const result = await patchData(`/${API_URL}/batch-status`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} Batch Status API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// send OTP for batch update
export const SendBatchOTP = async (data) => {
  try {
    console.log("SendBatchOTP Data:", data);
    const result = await postData(`/${API_URL}/send-otp`, data);
    console.log("SendBatchOTP Result:", result);
    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error(`Send ${ItemName} OTP API error:`, error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// get unique batch names
export const GetBatchNames = async () => {
  try {
    const result = await getData(`/${API_URL}/batch-names/all`);
    return {
      success: true,
      data: {
        data: result,
      },
    };
  } catch (error) {
    console.error(`Get ${ItemName} Batch Names API error:`, error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Update item (Single Generate Salary)
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error:
          error.status === 400
            ? error.data?.error || error.data?.message
            : error.message,
        status: error.status,
      },
    };
  }
};
